// extracted by mini-css-extract-plugin
module.exports = {"homeHero":"Index_homeHero__hnqYB","values":"Index_values__ofySD"};